import { motion } from "framer-motion";
import { BadgeCheck, Phone } from "lucide-react";

const FACTS = [
  "One point of contact, start to finish",
  "Local — born and bred under the maunga",
  "Every job photographed before & after",
];

export default function AboutJason() {
  return (
    <section id="about" data-testid="about-section" className="relative border-t border-white/[0.06] py-24 sm:py-32">
      <div className="mx-auto grid max-w-7xl items-center gap-16 px-5 sm:px-8 lg:grid-cols-12">
        <div className="relative lg:col-span-5">
          <motion.div
            initial={{ opacity: 0, scale: 0.96 }}
            whileInView={{ opacity: 1, scale: 1 }}
            viewport={{ once: true, margin: "-80px" }}
            transition={{ duration: 0.8, ease: [0.22, 1, 0.36, 1] }}
            className="relative"
          >
            <div
              className="clip-corner relative flex h-[26rem] flex-col justify-between overflow-hidden border border-white/10 bg-[#0D1320] p-8 pb-24 sm:p-10 sm:pb-24"
              data-testid="about-statement-card"
            >
              <span
                aria-hidden="true"
                className="pointer-events-none absolute -right-6 -top-10 select-none font-heading text-[14rem] font-extrabold leading-none text-orange-500/10"
              >
                J
              </span>
              <p className="relative font-mono text-[10px] uppercase tracking-[0.3em] text-slate-500">
                Total Roof Care Taranaki · Est. 2026
              </p>
              <p className="relative font-heading text-3xl font-extrabold uppercase leading-[1.05] tracking-tight text-slate-100 sm:text-4xl">
                Owner-led.
                <br />
                Your roof.
                <br />
                <span className="text-orange-400">No middlemen.</span>
              </p>
            </div>
            <span className="absolute -left-2 -top-2 h-6 w-6 border-l-2 border-t-2 border-orange-500" aria-hidden="true" />
            <div
              className="absolute -bottom-6 right-4 border border-white/10 bg-[#0B0F17]/85 px-5 py-4 backdrop-blur-xl"
              data-testid="about-badge"
            >
              <p className="font-mono text-[10px] uppercase tracking-[0.3em] text-orange-400">Owner-operator</p>
              <p className="mt-1 font-heading text-lg font-bold text-slate-100">Jason</p>
            </div>
          </motion.div>
        </div>

        <div className="lg:col-span-7">
          <p className="mb-4 font-mono text-xs uppercase tracking-[0.3em] text-orange-400">02 — Meet Jason</p>
          <h2 className="font-heading text-2xl font-bold tracking-tight text-slate-100 sm:text-3xl lg:text-4xl">
            The person who quotes it
            <br />
            is the person who does it.
          </h2>
          <div className="mt-6 max-w-xl space-y-4 text-base leading-relaxed text-slate-400">
            <p>
              Total Roof Care Taranaki is owner-led on purpose. When you call, you talk to
              Jason. When the quote arrives, Jason wrote it. When the work gets done, Jason's on
              your roof with his crew — no subcontractors, no hand-offs, no surprises.
            </p>
            <p>
              Years of working on roofs around the mountain means knowing exactly what Taranaki's
              wind, salt air and sideways rain do to a home — and how to build against it.
            </p>
          </div>
          <ul className="mt-8 space-y-3">
            {FACTS.map((f, i) => (
              <motion.li
                key={f}
                initial={{ opacity: 0, x: -20 }}
                whileInView={{ opacity: 1, x: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.5, delay: i * 0.1 }}
                className="flex items-center gap-3 text-sm text-slate-300"
              >
                <BadgeCheck className="h-4 w-4 shrink-0 text-orange-400" /> {f}
              </motion.li>
            ))}
          </ul>
          <a
            href="tel:0225477534"
            data-testid="about-call-btn"
            className="mt-10 inline-flex items-center gap-3 border border-white/15 px-7 py-4 font-mono text-sm uppercase tracking-[0.15em] text-slate-200 transition-colors duration-300 hover:border-orange-500/60 hover:text-orange-400"
          >
            <Phone className="h-4 w-4" /> Have a yarn — 022 547 7534
          </a>
        </div>
      </div>
    </section>
  );
}
